import { Pipe, PipeTransform } from '@angular/core';
import { Util } from './../_classes/util';

@Pipe({
  name: 'dataStr'
})
export class DataStrPipe implements PipeTransform {

  transform(valor: Date): string {
    if (valor) {
      return Util.dataMesAbrev(valor);
    } else {
      return "";
    }
  }

}
